import React from 'react';
import { Paper, Grid, Button } from '@material-ui/core';
import { checkPermission } from '../../utils_v2';
import ImportInterior from './ImportInterior';
import { trackActivity } from '../../../utils/mixpanel';
import LoopIcon from '@material-ui/icons/Loop';
import { regionalOneInstance, testLessor } from '../../../shared/components';
import AddIcon from '@material-ui/icons/Add';
import {  SaveAlt } from '@material-ui/icons';
const AddInteriorItem = ({ onAddItem, onExport, isExport, isImport, addPermission, onImport, getResponseBack, url, item, exportPermission,isSampleExport, page, syncData }) => {
    return (
        <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
            <Grid container spacing={1} alignItems="center">
                <Grid item md={8}></Grid>
                <Grid item md={4}>
                    <ul className="list-inline" style={{ float: 'right' }}>
                        {(regionalOneInstance || testLessor) && page == 'stc' && !item?.list?.length ?
                            <li className="list-inline-item">
                                <Button onClick={syncData} color="primary" size='small' variant="contained"> {<LoopIcon style={{fontSize:'18px'}}/>}Sync</Button>
                            </li> : null}
                        {exportPermission && isExport && item?.list?.length ?
                            <li className="list-inline-item">
                                <Button isExport={isExport} color='primary' variant='outlined' size='small' onClick={onExport} startIcon={<SaveAlt style={{ fontSize: '1.2rem' }} />} >Export</Button>
                            </li> : null
                        }
                        {addPermission && isImport ?
                            <li className="list-inline-item">
                                <ImportInterior isImport={isImport} getResponseBack={getResponseBack} trackActivity={trackActivity} url={url} onExport={() => onExport(isSampleExport ? "sample" : "")}/>
                            </li> : null
                        }
                         {addPermission ?
                            <li className="list-inline-item">
                                <Button onClick={onAddItem} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} /> ADD</Button>
                            </li> : null
                        }
                    </ul>
                </Grid>
            </Grid>
        </Paper>
    )
}
export default AddInteriorItem;